{
  "name": "spiral-galaxy",
  "doc": "A zoom that weakens with the radius (zoomexp < 1) and a rotation that strengthens with it: the centre holds, the arms stretch and wind. Dots become stars pulled into the spiral.",
  "cx": 0.5,
  "cy": 0.5,
  "zoom": 1.022,
  "zoomexp": 0.94,
  "rot": 0.004,
  "rotr": 0.03,
  "dx": 0,
  "dy": 0,
  "sx": 1,
  "sy": 1,
  "warp": 0,
  "warpScale": 4,
  "warpSpeed": 0.3,
  "decay": 0.965,
  "invert": 0,
  "hueShift": 0.003,
  "darkenCenter": 0.25,
  "wave": "DOTS",
  "waveColor": 2,
  "shapes": 0,
  "energy": [
    0.4,
    0.85
  ]
}